module.exports = __webpack_public_path__ + "img/日常任务.84a8bf5d.png";